module.exports = __webpack_public_path__ + "img/pledge-big-1.15477be1.jpg";